import { call, fork, put, takeEvery } from 'redux-saga/effects';
import EventApi from '../../../lib/api/event/EventApi';
import EventApiV2 from '../../../lib/api/event/EventApiV2';
import toastMsg from '../../../lib/toastMsg';
import { appActions } from '../app';
import { eventActions } from './index';
import eventToastMsg from '../../../constants/service/toastMsg/eventToastMsg';
import { TAG_SELECTED_LIST_EXCEL_FILE_NAME } from '../../../constants/service/app/tagConstants';
import { excelDownLoad, setRequestForm, setResponseListForm } from '../../../lib/common';
import { convertEventListRequest, convertEventListResponse } from './utils';

function* fetchList() {
  /**
   *  [진행중인 기획전] 진행중인 기획전 리스트 요청하기
   */
  yield takeEvery(eventActions.GET_IN_PROGRESS_EVENT_LIST_REQUEST, function* ({ payload }) {
    try {
      const convertPayload = convertEventListRequest(payload);
      const result = yield call(EventApiV2.getEventList, { ...convertPayload, isExposed: true });

      const data = {
        inProgressEventList: setResponseListForm(convertEventListResponse(result.events), result.totalCount, payload),
      };
      yield put({ type: eventActions.GET_IN_PROGRESS_EVENT_LIST_SUCCESS, payload: data });
    } catch (error) {
      toastMsg.error(eventToastMsg.GET_IN_PROGRESS_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [진행중인 기획전] 진행중인 기획전 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(eventActions.GET_IN_PROGRESS_EVENT_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(EventApi.getInProgressEventExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(eventToastMsg.GET_IN_PROGRESS_EVENT_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('진행중인 기획전 리스트', result.data.InProgressEventListExcelSheet);
      }
    } catch (error) {
      toastMsg.error(error.message || eventToastMsg.GET_IN_PROGRESS_EVENT_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [전체 기획전] 전체 기획전 리스트 요청하기
   */
  yield takeEvery(eventActions.GET_ALL_EVENT_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(EventApiV2.getEventList, convertEventListRequest(payload));
      toastMsg.success(eventToastMsg.GET_ALL_LIST_REQUEST_SUCCESS);
      const data = {
        allEventList: setResponseListForm(convertEventListResponse(result.events), result.totalCount, payload),
      };
      yield put({ type: eventActions.GET_ALL_EVENT_LIST_SUCCESS, payload: data });
    } catch (error) {
      toastMsg.error(eventToastMsg.GET_ALL_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [전체 기획전] 전체 기획전 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(eventActions.GET_ALL_EVENT_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(EventApi.getAllEventExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(eventToastMsg.GET_ALL_EVENT_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('전체 기획전 리스트', result.data.allEventListExcelSheet);
      }
    } catch (error) {
      toastMsg.error(error.message || eventToastMsg.GET_ALL_EVENT_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [진행중인 기획전, 전체 기획전] 태그 리스트 요청하기
   */
  yield takeEvery(eventActions.GET_EVENT_TAG_COLUMN_TAG_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(EventApi.getEventTagColumnTagList, setRequestForm(payload));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      /**
       *  태그 보기 모달 띄우기
       */
      yield put(
        appActions.appToggleModal({
          name: 'tagListViewModal',
          data: result.data,
        }),
      );
    } catch (e) {
      toastMsg.error(eventToastMsg.GET_EVENT_TAG_COLUMN_TAG_LIST_REQUEST_ERROR, e);
    }
  });

  /**
   *  [기획전 등록,편집] 선택된 기획전 상품 excel 리스트 다운로드 하기
   */
  yield takeEvery(eventActions.GET_SELECTED_EVENT_PRODUCT_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(EventApi.getSelectedEventProductExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(eventToastMsg.GET_EVENT_PRODUCT_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('선택된 기획전 아이템 리스트', result.data.eventItemExcelSheet);
      }
    } catch (error) {
      toastMsg.error(error.message || eventToastMsg.GET_EVENT_PRODUCT_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   *  [기획전 등록,편집] 선택 태그 리스트 엑셀 다운로드
   */
  yield takeEvery(eventActions.GET_EVENT_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(EventApi.getEventTagSelectedListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(eventToastMsg.GET_EVENT_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad(TAG_SELECTED_LIST_EXCEL_FILE_NAME, result.data.tagSelectedExcelSheet);
    } catch (e) {
      toastMsg.error(e.message || eventToastMsg.GET_EVENT_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, e);
    }
  });
}

export default function* widgetSaga() {
  yield fork(fetchList);
}
